import { makeAutoObservable } from 'mobx';
import { FilterCondition } from 'shared/types/flowstep';

interface FilterManagerOptions {
  allowEmptyValues?: boolean;
}

export class FilterManagerState {
  conditions: FilterCondition[] = [];
  private allowEmptyValues: boolean;

  constructor(conditions: FilterCondition[], options?: FilterManagerOptions) {
    makeAutoObservable(this);

    this.conditions = conditions.map((condition) => ({ ...condition }));
    this.allowEmptyValues = options?.allowEmptyValues ?? true;
  }

  addCondition() {
    this.conditions.push({
      fieldName: '',
      value: '',
      operator: '',
      joinOperator: 'AND',
      type: '',
    });
  }

  deleteCondition(index: number) {
    this.conditions.splice(index, 1);
  }

  get isValid() {
    return this.conditions.every((condition) => {
      if (!condition.fieldName || !condition.operator) return false;
      if (!this.allowEmptyValues && !condition.value) return false;
      return true;
    });
  }
}
